module.exports = __webpack_public_path__ + "img/fast_eller_rorligt@2x.7e6d8b27.jpg";